export const domainArr = JSON.parse(process.env.REACT_APP_DOMAIN_ARR || "[]");
